"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _cloudinaryCore = _interopRequireDefault(require("cloudinary-core"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/*
 * The image tag can be pass props and it will determine if it need to use
 * cloudinary or just a image path
 * @props
 * - src (optional, only need if not using cloudinary)
 * - cloudPublicId
 * - cloudName
 * - cloudTintOpacity
 * - cloudTintColor
 * - imageStyle
 * - className -- we are puttin it on the wrapper, and we can target the img tag inside...
 */
var ImageTag = /*#__PURE__*/function (_Component) {
  _inherits(ImageTag, _Component);
  var _super = _createSuper(ImageTag);
  function ImageTag(props) {
    var _this;
    _classCallCheck(this, ImageTag);
    _this = _super.call(this, props);
    _this.state = {
      isLoaded: false,
      loadError: ""
    }; // used as "in" for transitions
    _this.handleImageLoad = _this.handleImageLoad.bind(_assertThisInitialized(_this));
    _this.handleImageLoadError = _this.handleImageLoadError.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(ImageTag, [{
    key: "handleImageLoad",
    value: function handleImageLoad(e, src) {
      this.setState({
        isLoaded: true,
        src: src
      });
    }
  }, {
    key: "handleImageLoadError",
    value: function handleImageLoadError(e) {
      var _ref = e || "Error Loading",
        message = _ref.message;
      this.setState({
        loadError: message
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        className = _this$props.className,
        cloudTintOpacity = _this$props.cloudTintOpacity,
        cloudTintColor = _this$props.cloudTintColor,
        assetConfig = _this$props.assetConfig,
        cloudPublicId = _this$props.cloudPublicId,
        cloudName = _this$props.cloudName,
        imageStyle = _this$props.imageStyle,
        page = _this$props.page,
        format = _this$props.format,
        quality = _this$props.quality,
        crop = _this$props.crop,
        startOffset = _this$props.startOffset,
        width = _this$props.width,
        height = _this$props.height,
        heightLimit = _this$props.heightLimit,
        widthLimit = _this$props.widthLimit,
        type = _this$props.type,
        metaConfig = _this$props.metaConfig,
        onClick = _this$props.onClick;
      var _ref2 = this.props || this.state,
        src = _ref2.src; // this is a backup if we are not using cloudinary
      var altText = metaConfig ? metaConfig.altText : "";
      var _this$state = this.state,
        isLoaded = _this$state.isLoaded,
        loadError = _this$state.loadError;
      var effect = cloudTintOpacity && cloudTintColor ? "colorize:".concat(cloudTintOpacity, ",co_rgb:").concat(cloudTintColor) : null;
      var hasCropConfig = assetConfig && typeof assetConfig.cropCoordinates !== "undefined";
      var cropCoordinates = hasCropConfig ? assetConfig.cropCoordinates : {};
      var imgClass = "".concat(className || "image-container");
      var publicId = cloudPublicId; // this may need to be modified for some formats
      var fileFormat = type === "video" || type === "pdf" ? "jpg" : format; // Ensure other formats will revert to jpg

      if (this.props && (cloudPublicId || src)) {
        // let contents;
        // if (isPoster && cloudPublicId) {
        //   // looad like we can't fade in the poster, or else looking for wrong envet
        //   //  data-fade={true}
        //   contents = (
        //     <Video
        //       ref={c => {
        //         this.element = c ? c.element : null;
        //       }}
        //       cloudName={cloudName}
        //       preload={"none"}
        //       poster={src}
        //       onLoad={this.onImageLoad}
        //       onError={this.onImageLoadError}
        //     />
        //   );
        // } else if (cloudPublicId) {
        //   contents = (
        //     <Image
        //       ref={c => {
        //         this.element = c ? c.element : null;
        //       }}
        //       cloudName={cloudName}
        //       publicId={cloudPublicId}
        //       width={context === "scene-browser" ? 300 : 1800}
        //       style={imageStyle}
        //       onLoad={this.onImageLoad}
        //       onError={this.onImageLoadError}
        //       data-fade={true}
        //       alt={altText}
        //     >
        //       <Transformation
        //         effect={effect}
        //         {...cropCoordinates}
        //         crop={hasCropConfig ? "crop" : "scale"}
        //       />
        //     </Image>
        //   );
        // } else {
        //   contents = (
        //     <img
        //       ref={el => {
        //         this.element = el;
        //       }}
        //       style={imageStyle}
        //       src={src}
        //       width={1800}
        //       style={imageStyle}
        //       onLoad={this.onImageLoad}
        //       onError={this.onImageLoadError}
        //       data-fade={true}
        //       alt={altText}
        //     />
        //   );
        // }

        var extension = /(?:\.([^.]+))?$/;
        if ((type === "video" || type === "pdf") && cloudPublicId) {
          /*
          Both PDF and videos have to add an extension to the cloudPublicId to 
          insure an image is returned. They still use the same tag, but pass a
          few extra params. Seems there are some cases where a native extension
          is added so we remove here.
          */
          publicId = "".concat(cloudPublicId).concat(typeof extension.exec(cloudPublicId)[1] !== "undefined" ? "" : ".jpg");
        }

        // Set up an object so we can do some conditional attribute adds
        var imageProps = {
          style: imageStyle,
          width: width || "auto",
          height: height || "auto"
        };
        if (altText) {
          imageProps.alt = altText;
        }
        var loaderProps = {};
        if (!src) {
          var cloudinaryCore = new _cloudinaryCore["default"].Cloudinary({
            cloud_name: cloudName
          });
          // create object for transformations
          var transformationObj = {
            format: fileFormat,
            fetch_format: "auto",
            resource_type: type === "video" ? type : "image"
          };
          var transformations = []; // array of transformations to apply in order

          // add page information for pdf thumb
          if (type === "pdf") {
            transformations.push({
              page: type === "pdf" ? page : "",
              startOffset: startOffset
            });
          }
          if (type === "video") {
            transformations.push({
              startOffset: startOffset
            });
          }

          // add crop information if present
          if (cropCoordinates && !(0, _isUndefined2["default"])(cropCoordinates)) {
            transformations.push(_objectSpread({
              crop: hasCropConfig ? "crop" : type === "pdf" ? crop : "fit"
            }, cropCoordinates));
          }

          // make sure things fit if limits were passed
          transformations.push({
            width: widthLimit || "1800",
            height: heightLimit || "1800",
            crop: "limit"
          });
          if (effect) {
            transformations.push({
              effect: effect
            });
          }
          transformations.push({
            client_hints: true,
            dpr: "auto",
            quality: type === "pdf" ? quality : "auto"
          });

          // TODO pass information about transformations to url generation
          transformationObj.transformation = transformations;
          src = cloudinaryCore.url(cloudPublicId, transformationObj);
        }
        imageProps.src = src;
        return /*#__PURE__*/_react["default"].createElement("figure", {
          className: imgClass,
          onClick: onClick
        }, this.props.overlay ? this.props.overlay : null, /*#__PURE__*/_react["default"].createElement("img", _extends({}, imageProps, {
          onLoad: function onLoad(e) {
            return _this2.handleImageLoad(e, src);
          },
          onError: function onError(e) {
            return _this2.handleImageLoadError(e);
          }
          // data-fade={!isLoaded}
        })), this.props.children, !isLoaded ? /*#__PURE__*/_react["default"].createElement(_Loader["default"], _extends({}, loaderProps, {
          type: "asset-loader",
          message: loadError,
          size: 20,
          thickness: 5
        })) : null);
      } else {
        return null;
      }
    }
  }]);
  return ImageTag;
}(_react.Component);
ImageTag.defaultProps = {};
ImageTag.propTypes = {
  src: _propTypes["default"].string,
  cloudPublicId: _propTypes["default"].string,
  cloudName: _propTypes["default"].string,
  cloudTintOpacity: _propTypes["default"].string,
  cloudTintColor: _propTypes["default"].string,
  config: _propTypes["default"].object,
  imageStyle: _propTypes["default"].object,
  className: _propTypes["default"].string,
  assetConfig: _propTypes["default"].object,
  descriptionStyle: _propTypes["default"].object
};
var _default = ImageTag;
exports["default"] = _default;